import { useState } from 'react';
import clsx from 'clsx';
import useAddPostComment from 'sdk/hooks/useAddPostComment';
import useGetPostCommentsByPostId from 'sdk/hooks/useGetPostCommentsByPostId';
import s from './Comments.module.scss';
import styles from './PostComments.module.scss';
import { OptionType } from 'components/shared/Select';
import { useActions } from 'store/useActions';
import BackBtn from 'components/shared/BackBtn';
import Avatar from 'components/shared/Avatar';
import NoContent from 'components/shared/NoContent/NoContent';
import useUser from 'sdk/hooks/user/useProfile';
import Button from 'components/shared/Button';
import { ReactComponent as IconSend } from 'images/icons/send.svg';
import Input from 'components/shared/Input';
import { useSwipeable } from 'react-swipeable';
import { useNavigate } from 'react-router-dom';
const options: OptionType[] = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
];

function Comments(props: any) {
  const [comment, setComment] = useState('');
  const [order, setOrder] = useState(options[0]);
  const { setIsButtonMenuVisible } = useActions();
  const addCommentMutation = useAddPostComment();
  const {
    data: comments,
    isLoading,
    refetch,
  } = useGetPostCommentsByPostId(props?.data?.data?.id, order.value);
  const className = props?.className;
  const navigate = useNavigate();
  const { data: currentUser } = useUser();

  const handleSubmitComment = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!comment.trim() || !currentUser) return;

    try {
      await addCommentMutation.mutateAsync({
        postId: props?.data?.data?.id,
        comment: comment.trim(),
      });
      setComment('');
    } catch (error) {
      console.error('Error adding comment:', error);
    }
  };

  const commentsListSwipeHandlers = useSwipeable({
    onSwipedUp: e => {
      e.event.stopPropagation();
    },
    onSwipedDown: e => {
      e.event.stopPropagation();
    },
    delta: 10,
  });
  const commentsHeaderSwipeHandlers = useSwipeable({
    onSwipedUp: e => {
      e.event.stopPropagation();
    },
    onSwipedDown: e => {
      e.event.stopPropagation();
      setIsButtonMenuVisible(true);
      props?.onClose();
    },
    delta: 10,
  });

  return (
    <div className={clsx(className, s.container)}>
      <div
        className={clsx(styles.commentsList, 'scroll scroll-y')}
        id="scrollTo"
        onWheel={(e: any) => {
          e.stopPropagation();
          e.preventDefault();
          e.nativeEvent.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
        }}
        {...commentsHeaderSwipeHandlers}
      >
        <div className={styles.header}>
          <div className={styles.dragHandle} />
          <BackBtn className={styles.btnClose} onClick={() => {
            setIsButtonMenuVisible(true)
            props?.onClose()
          }} />
          <span className={styles.title}>Comments</span>
          {/* <PostSelect
          className={styles.headerSelect}
          options={options}
          value={order}
          onChange={(newValue) => {
            console.log('onChange triggered in PostComments');
            setOrder(newValue);
          }}
        /> */}
        </div>

        <div className={clsx(styles.commentsList, 'scroll scroll-y')} id="scrollTo">
          {isLoading ? (
            <div className={styles.loading}>Loading comments...</div>
          ) : comments && comments.length > 0 ? (
            comments.map(comment => (
              <div
                key={comment.id}
                className={styles.commentItem}
                style={{ padding: 16 }}
                onClick={() => navigate(`/profile/${comment?.user_id}`)}
              >
                <Avatar
                  className={styles.commentAvatar}
                  username={comment.user?.username || ''}
                  image={comment.user?.avatar || ''}
                />
                <div className={styles.commentContent}>
                  <div className={styles.commentHeader} style={{ marginBottom: '12px' }}>
                    <span className={styles.username}>{comment.user?.username}</span>
                    <span className={styles.date}>
                      {' '}
                      {new Date(comment.created_at).toLocaleDateString()}
                    </span>
                  </div>
                  <p className={styles.commentText}>{comment.comment}</p>
                </div>
              </div>
            ))
          ) : (
            <NoContent
              className={styles.noContent}
              title="No data"
              message="No comments yet. Be the first to add a comment"
              small
            />
          )}
        </div>

        {currentUser ? (
          <form className={styles.commentInputRow} onSubmit={handleSubmitComment}>
            <Avatar
              className={styles.commentInputAvatar}
              username={currentUser.username}
              image={currentUser.avatar}
            />
            <div className={styles.commentInputRowItem}>
              <Input
                wide
                className={styles.commentInput}
                placeholder="Add a comment here..."
                value={comment}
                // @ts-ignore
                onChange={e => setComment(e.target.value)}
                maxLength={2200}
              />
              <Button
                className={styles.sendBtn}
                iconBtn
                submit
                type="submit"
                disabled={addCommentMutation.isLoading}
              >
                <IconSend />
              </Button>
            </div>
          </form>
        ) : (
          <div className={styles.commentInputRow}>
            <Button
              className={styles.loginToComment}
              iconBtn
              submit
              onClick={() => navigate('/sign-up')}
            >
              Log in to comment
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Comments;
